<template>
    <div>
        <div class="container" style="display: flex; align-items: flex-start; padding: 0 30px 30px">
            <div class="leftbox" style="width: 15%">
                <div class="titlea">
                    <el-breadcrumb separator="/">
                        <el-breadcrumb-item> <i class="el-icon-setting"></i> 类别设定 </el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
                <ul>
                    <li
                        v-for="(item, index) in selectList"
                        :key="index"
                        v-bind:class="{ bgSelect: item.type_no == current }"
                        @click="selectValue(item.type_no, index, item.type_name)"
                    >
                        {{ item.type_name }}
                    </li>
                </ul>
            </div>
            <!-- <el-menu style="width:15%;overflow: hidden;" background-color="#ecf5ff" text-color="#000">
                <el-submenu index="1">
                    <template slot="title">
                        <i class="el-icon-location"></i>
                        <span>类别设定</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item index="1-3" v-for="(item,index) in selectList" :key="index" v-bind:class="{ bgSelect:index==current}"  @click="selectValue(item.type_no,index)">{{item.type_name}}</el-menu-item>
                    </el-menu-item-group>
                </el-submenu>
            </el-menu> -->
            <div style="width: 85%">
                <div class="handle-box" style="display: flex; align-items: center; justify-content: space-between">
                    <el-select v-model="type_no" filterable placeholder="请选择类别" class="handle-select mr10" @change="selectValue">
                        <el-option v-for="(item, index) in selectList" :key="index" :label="item.type_name" :value="item.type_no">
                            <!-- <span style="margin-left:10px">{{ item.type_name }}</span>
                            <span style="float: left; color: #8492a6; font-size: 13px">{{ item.type_no }}</span> -->
                        </el-option>
                    </el-select>
                    <div>
                        <el-button type="primary" icon="el-icon-plus" v-if="perData.allow_add == 1" @click="handleAdd">添加</el-button>
                        <el-button
                            type="danger"
                            icon="el-icon-delete"
                            class="handle-del mr10"
                            @click="delAllSelection"
                            v-if="perData.allow_dele == 1"
                            >批量删除</el-button
                        >
                    </div>
                </div>
                <el-table
                    :data="tableData"
                    border
                    stripe
                    class="table"
                    ref="multipleTable"
                    header-cell-class-name="table-header"
                    @selection-change="handleSelectionChange"
                >
                    <el-table-column type="selection" width="55" align="center"></el-table-column>
                    <el-table-column prop="kind_no" label="项目代号" width="100" align="center"></el-table-column>
                    <el-table-column prop="kind_name" label="项目名称"></el-table-column>
                    <el-table-column prop="kind_ename" label="别名"></el-table-column>
                    <el-table-column label="状态" align="center">
                        <template slot-scope="scope">
                            <el-switch
                                v-model="scope.row.status"
                                :active-value="1"
                                :inactive-value="0"
                                @change="tableDatastates(scope.row)"
                            >
                            </el-switch>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="250" align="center" v-if="perData.allow_edit == 1 || perData.allow_dele == 1">
                        <template slot-scope="scope">
                            <el-button type="primary" plain icon="el-icon-edit" @click="handleEdit(scope)" v-if="perData.allow_edit == 1"
                                >{{ $t('common.edit') }}</el-button
                            >
                            <el-button
                                type="danger"
                                plain
                                icon="el-icon-delete"
                                class="red"
                                @click="handleDelete(scope)"
                                v-if="perData.allow_dele == 1"
                                >{{ $t('common.delete') }}</el-button
                            >
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination
                        background
                        layout="total, prev, pager, next"
                        :current-page="pageIndex"
                        :page-sizes="[5, 10, 20, 50, 100]"
                        :page-size="pageSize"
                        :total="pageTotal"
                        @current-change="handlePageChange"
                        @size-change="pageSizeChange"
                    ></el-pagination>
                </div>
            </div>
        </div>
        <!-- 添加类别 -->
        <el-dialog :title="isAdd ? $t('common.add') : $t('common.edit')" :visible.sync="addData_isshow">
            <span
                style="text-align: center; font-weight: bold; font-size: 16px; display: block; margin-bottom: 10px"
                v-text="titleName"
            ></span>
            <el-form label-width="100px">
                <el-form-item label="项目代号">
                    <el-input type="text" v-model="addData.kind_no" :disabled="!isAdd"></el-input>
                </el-form-item>
                <el-form-item label="项目名称">
                    <el-input v-model="addData.kind_name" @blur="interName"></el-input>
                </el-form-item>
                <el-form-item label="别名">
                    <label slot="label">别&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名</label>
                    <el-input v-model="addData.kind_ename" @blur="intereName"></el-input>
                </el-form-item>
                <el-form-item label="状态">
                    <label slot="label">状&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;态</label>
                    <el-switch v-model="addData.status" :active-value="1" :inactive-value="0"> </el-switch>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="clearStatus">取 消</el-button>
                <el-button type="primary" @click="saveAdd">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { fetchData } from '../../api/index';
import {
    apisetList,
    apisetListSon,
    apisetDetailSon,
    apiaddSetSon,
    apimodifySetSon,
    apidelSetSon,
    apiCurrentPermisson,
    apiaddSetSonstatus
} from '@/request/api';
export default {
    name: 'basetable',
    data() {
        return {
            name: '',
            value: 'kind',
            type_no: '',
            titleName: '',
            selectList: [],
            delList: [],
            pageIndex: 1,
            pageSize: 10,
            tableData: [],
            perData: '',
            pageTotal: 0,
            addData: {},
            current: 0,
            isAdd: true,
            addData_isshow: false
        };
    },
    watch: {
        type_no: function (val, oldval) {
            this.getData();
        }
    },
    created() {
        this.getListData();
        this.getData();
        this.getPermission();
        this.type_no = localStorage.getItem('type_no');
        this.current = 0;
    },
    activated() {
        this.getListData();
        this.getData();
        this.getPermission();
        this.type_no = localStorage.getItem('type_no');
        this.current = 0;
    },
    methods: {
        clearStatus() {
            this.addData_isshow = false;
            this.addData = {};
            this.getData();
        },
        tableDatastates(row) {
            let data = row;
            apiaddSetSonstatus(data).then((res) => {
                if (res.code === 2000) {
                    this.$message.success(res.msg);
                } else {
                    this.$message.success(res.data.info);
                }
                this.getData();
            });
        },
        // 正则表达式  不能出现`'
        interName() {
            var pattern1 = /^[^\`]*$/;
            var pattern2 = /^[^\']*$/;
            if (this.addData.kind_name) {
            } else if (!pattern2.test(this.addData.kind_name) || !pattern1.test(this.addData.kind_name)) {
                this.addData.kind_name = '';
                this.$message.error("不能包含`或者'符号");
                return;
            }
        },
        intereName() {
            var pattern1 = /^[^\`]*$/;
            var pattern2 = /^[^\']*$/;
            if (this.addData.kind_ename) {
            } else if (!pattern2.test(this.addData.kind_ename) || !pattern1.test(this.addData.kind_ename)) {
                this.addData.kind_ename = '';
                this.$message.error("不能包含`或者'符号");
                return;
            }
        },
        // 获取下拉框信息----------------------------------------------------------------------------------------------------
        getListData() {
            apisetList({}).then((res) => {
                if (res.code == 2000) {
                    this.selectList = res.data.data;
                    this.titleName = res.data.data[0].type_name;
                    this.type_no = res.data.data[0].type_no;
                    localStorage.setItem('type_no', res.data.data[0].type_no);
                } else {
                    // this.$message.error(res.msg);
                }
            });
        },
        // 获取列表信息----------------------------------------------------------------------------------------------------
        getData() {
            this.$load.show();
            apisetListSon({
                type_no: localStorage.getItem('type_no'),
                page: this.pageIndex,
                page_size: this.pageSize,
                keyword: this.name
            }).then((res) => {
                this.$load.close();
                if (res.code == 2000) {
                    this.tableData = res.data.data;
                    this.pageTotal = res.data.page_total;
                } else {
                    // this.$message.error(res.msg);
                }
            });
        },
        //下拉选择部门----------------------------------------------------------------------------------------------------
        selectValue(number, inNO, name) {
            //
            this.pageIndex = 1;
            localStorage.setItem('type_no', number);
            this.titleName = name;
            this.type_no = number;
            this.getData();
            this.current = number;
        },
        // 触发搜索按钮----------------------------------------------------------------------------------------------------
        handleSearch() {
            this.pageIndex = 1;
            this.getData();
        },
        //获得页面按钮的权限（添加，修改，删除）
        getPermission() {
            apiCurrentPermisson({
                id: '10'
            }).then((res) => {
                if (res.code == 2000) {
                    //
                    this.perData = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        // 添加----------------------------------------------------------------------------------------------------
        handleAdd() {
            this.isAdd = true;
            this.addData_isshow = true;
            this.addData = {};
            this.addData.status = 1;
            this.type_no = localStorage.getItem('type_no');
        },
        saveAdd() {
            let data = this.addData;
            this.addData.type_no = localStorage.getItem('type_no');
            if (this.isAdd) {
                apiaddSetSon(data).then((res) => {
                    if (res.code == 2000) {
                        this.$message({ message: '添加成功', type: 'success' });
                        this.addData_isshow = false;
                        this.getData();
                    } else {
                        this.$message.error(res.data.info);
                    }
                });
            } else {
                apimodifySetSon(data).then((res) => {
                    if (res.code == 2000) {
                        this.$message({ message: '修改成功', type: 'success' });
                        this.addData_isshow = false;
                        this.getData();
                    } else {
                        this.$message.error(res.data.info);
                    }
                });
            }
        },
        // 删除操作----------------------------------------------------------------------------------------------------
        handleDelete(scope) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    apidelSetSon({
                        type_no: localStorage.getItem('type_no'),
                        kind_no: scope.row.kind_no
                    }).then((res) => {
                        if (res.code == 2000) {
                            this.$message({ message: '删除成功', type: 'success' });
                            this.getData();
                        } else {
                            this.$message.error(res.data.info);
                        }
                    });
                })
                .catch(() => {});
        },
        // 多选删除操作
        handleSelectionChange(user) {
            let arr = [];
            let arr1 = [];
            user.forEach(function (item, index, array) {
                arr.push(item.kind_no);
            });
            this.delList = arr;
        },
        delAllSelection() {
            if (this.delList.length <= 0) {
                this.$message({ message: '请先选择需要操作的对象', type: 'error' });
                return;
            }
            this.$confirm('此操作将批量删除, 是否继续?', '批量删除提示', {
                confirmButtonText: this.$t('common.confirm') ,
                cancelButtonText: this.$t('common.cancel') ,
                type: 'warning'
            })
                .then(() => {
                    apidelSetSon({
                        type_no: localStorage.getItem('type_no'),
                        kind_no: this.delList.join(',')
                    }).then((res) => {
                        if (res.code == 2000) {
                            this.$message({ message: '删除成功', type: 'success' });
                            this.getData();
                        } else {
                            this.$message.error(res.data.info);
                        }
                    });
                })
                .catch(() => {
                    // this.$message({ type: 'info',  message: '已取消删除' });
                });
        },
        // 编辑操作----------------------------------------------------------------------------------------------------
        handleEdit(scope) {
            this.addData_isshow = true;
            this.isAdd = false;
            this.addData = scope.row;
        },

        // 分页导航----------------------------------------------------------------------------------------------------
        handlePageChange(val) {
            this.pageIndex = val;
            this.getData();
        },
        pageSizeChange(val) {
            //
            this.pageSize = val;
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    /* margin-bottom: 20px; */
    height: 50px;
    line-height: 50px;
    text-align: right;
}

.handle-select {
    width: 250px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
<style>
.el-table thead {
    color: #000;
    font-weight: bold;
}
.el-table--striped .el-table__body tr.el-table__row--striped td {
    background: #ecf5ff;
}
.el-table th {
    background: #ecf5ff !important;
}
.titlea .el-breadcrumb__item:last-child .el-breadcrumb__inner {
    height: 50px;
    line-height: 50px;
    color: #000;
    font-weight: bold;
    font-size: 16px;
}
.leftbox ul {
    background: #ecf5ff;
    height: 700px;
    overflow-y: scroll;
}
.leftbox ul li {
    list-style: none;
    padding: 10px;
    font-size: 14px;
}
.bgSelect {
    background: #409eff;
    color: #fff;
}
.el-dialog {
    width: 40%;
}
@media screen and (max-width: 768px) {
    .el-dialog {
        width: 100% !important;
    }
    .el-message-box {
        width: 100%;
    }
    .handle-input {
        display: block !important;
        width: 100% !important;
        margin: 10px 0;
    }
}
</style>
